// --- Core ---
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {get, set} from "local-storage";
// --- SaniQ ---
import {API} from "api";
import {Locale, safeLocale} from "src/config/i18n";

interface AppState {
  locale: Locale;
}

const initialState: AppState = {
  locale: undefined
};

const appSlice = createSlice({
  // eslint-disable-next-line formatjs/no-literal-string-in-object
  name: 'app',
  initialState,
  reducers: {
    switchLocale: {
      reducer: (state, action: PayloadAction<Locale>) => {
        state.locale = action.payload;
      },
      prepare: (unsafeLocale: string) => {
        const locale = safeLocale(unsafeLocale);
        const storedLocale = get<string>('locale');

        if (locale !== storedLocale) {
          set('locale', locale);
        }
        document.documentElement.lang = locale;
        API.locale = locale;
        return {payload: locale};
      }
    }
  }
});

export const {switchLocale} = appSlice.actions;

export default appSlice.reducer;
